import { useEffect, useState, useCallback } from "react";
import { apiClient } from "../../lib/api";
import toast from "react-hot-toast";
import { TagSelector } from "./TagSelector";
import { Tag } from "../../lib/types";

export const TagManager = () => {
  const [tags, setTags] = useState<Tag[]>([]);
  const [newTag, setNewTag] = useState("");
  const [isLoading, setIsLoading] = useState(false);
  const [selectedTags, setSelectedTags] = useState<number[]>([]);
  const [refreshTrigger, setRefreshTrigger] = useState(0);

  const fetchTags = useCallback(async () => {
    try {
      const data = await apiClient.get("/tags") as Tag[];
      setTags(data);
    } catch (err: any) {
      toast.error("タグの取得に失敗しました");
    }
  }, []);

  useEffect(() => {
    fetchTags();
  }, [fetchTags, refreshTrigger]);

  const handleAddTag = async (e: React.FormEvent) => {
    e.preventDefault();
    if (!newTag.trim()) return;

    setIsLoading(true);
    try {
      await apiClient.post("/tags", { tag: newTag.trim() });
      toast.success("タグを追加しました");
      setNewTag("");
      setRefreshTrigger(prev => prev + 1);
    } catch (err: any) {
      toast.error("タグの追加に失敗しました");
    } finally {
      setIsLoading(false);
    }
  };

  const handleDeleteTag = async (id: number) => {
    if (!confirm("このタグを削除してもよろしいですか？")) return;

    try {
      await apiClient.delete(`/tags/${id}`);
      toast.success("タグを削除しました");
      setRefreshTrigger(prev => prev + 1);
    } catch (err: any) {
      toast.error("タグの削除に失敗しました");
    }
  };

  return (
    <div className="space-y-6">
      <h2 className="text-xl font-bold">タグ管理</h2>

      <form onSubmit={handleAddTag} className="flex gap-2">
        <input
          type="text"
          value={newTag}
          onChange={(e) => setNewTag(e.target.value)}
          placeholder="新しいタグ"
          className="px-3 py-2 border rounded"
        />
        <button
          type="submit"
          disabled={isLoading || !newTag.trim()}
          className="px-4 py-2 bg-blue-500 text-white rounded disabled:opacity-50"
        >
          追加
        </button>
      </form>

      <div className="mt-8">
        <h3 className="text-lg font-medium mb-4">既存のタグ一覧</h3>
        <TagSelector
          key={tags.length}
          selectedTags={selectedTags}
          onTagsChange={setSelectedTags}
          showDeleteButton
          onDeleteTag={handleDeleteTag}
        />
      </div>
    </div>
  );
};
